<template>
  <v-data-table
    v-if="outObj"
    :items="outObj"
    :headers="assessmentHeaders"
    show-expand
    single-select
    single-expand
    item-key="idx"
    :expanded.sync="expandedAssessments"
    disable-pagination
    hide-default-footer
    no-data-text="Информация о assessmentsData отсутствует"
  >
    <template #[`item.id`]="{ item }">
      <span class="text--disabled">{{ item.id }}.</span>
    </template>
    <template #[`item.condition`]="{ value }">
      <span v-if="value" class="font-weight-medium">{{ value }}</span>
      <span v-else class="warning--text"> ( пусто ) </span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="td-expanded pa-2">
        <compare-economic-editor
          :value="item"
          @change="
            item => {
              const idx = outObj.findIndex(el => el.idx === item.idx)
              outObj[idx] = item
              $set(outObj, idx, item)
              doChange()
            }
          "
          @delete="
            () => {
              const idx = outObj.findIndex(el => el.idx === item.idx)
              outObj.splice(idx - 1, 1)
              doChange()
            }
          "
          @blur="doBlur"
        />
      </td>
    </template>
    <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded, index }">
      <td class="text-right">
        <v-btn
          icon
          @click="
            () => {
              expand(!isExpanded)
              $emit('changeExpand', index, isExpanded)
            }
          "
          class="v-data-table__expand-icon"
          :class="{ 'v-data-table__expand-icon--active': isExpanded }"
        >
          <v-icon>mdi-pencil-circle-outline</v-icon>
        </v-btn>
      </td>
    </template>
    <template #footer>
      <div class="d-flex pt-3">
        <div class="text-body-1">
          <span>Максимальное значение: </span>
          <span class="font-weight-bold"> {{ maxValue }}</span>
        </div>

        <v-spacer />
        <v-btn
          v-if="0"
          color="accent"
          fab
          small
          @click="
            () => {
              outObj.push({
                ...ASSESSMENT_ORGANIZATION_DEFAULT(),
                id: value.length + 1,
              })
              expandAdd(outObj)
              doChange()
            }
          "
        >
          <v-icon> mdi-plus </v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { ASSESSMENT_ORGANIZATION_DEFAULT } from './const'
import { DEFAULT_ECONOMIC } from '@/components/expSummary/summaryScore/assessmentConst'
import CompareEconomicEditor from './CompareEconomicEditor.vue'
import { copyObject } from '@/lib/objects'

export default {
  name: 'CompareTableAssessment',
  components: {
    CompareEconomicEditor,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    expandedAssIndex: {
      type: Number,
      default: null,
    },
  },
  watch: {
    expandedAssIndex: 'changeExpandIndex',
  },
  computed: {
    ...mapGetters(['plp_task_id', 'compare_data']),
    maxValue() {
      if (!this.outObj?.length) return 0
      return Math.max(...this.outObj.map(item => item.resultScore)) || 0
    },
  },
  data() {
    return {
      outObj: null,
      ASSESSMENT_ORGANIZATION_DEFAULT,
      expandedAssessments: [0],
      economic: [],
      // assessment
      assessment: {
        loading: false,
        error: '',
        data: null,
      },
      assessmentHeaders: [
        {
          text: '№',
          value: 'id',
          width: '10px',
          sortable: false,
        },
        {
          text: 'Показание',
          value: 'condition',
          sortable: false,
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  async created() {
    this.outObj = copyObject(this.value) || []
  },
  methods: {
    copyObject,
    expand(item = null) {
      this.expandedAssessments = item ? [item] : []
    },
    changeExpandIndex() {
      this.$nextTick(() => {
        this.expand(this.outObj[this.expandedAssIndex])
      })
    },

    deleteAssessments(idx) {
      this.outObj.splice(idx - 1, 1)
      this.expand(null)
    },
    addAssessment() {
      this.outObj.push(DEFAULT_ECONOMIC())

      this.$nextTick(() => {
        const lg = this.outObj?.length || 0
        this.expand(this.outObj[lg - 1])
      })
    },
    expandAdd(value) {
      this.$nextTick(() => {
        const lg = value?.length || 0
        this.expand(value[lg - 1])
      })
    },
    doChangeItem(item) {
      const idx = item.idx - 1
      this.economic[idx] = item
    },
    doChange() {
      this.$emit('change', this.outObj)
    },
    doBlur() {
      this.$emit('blur')
    },
  },
}
</script>
